module.exports = __webpack_public_path__ + "img/card_title1.8b947883.png";